import { DialogCore, DialogCoreBaseProps, DialogCoreTypeProps } from 'omakase/Dialog/DialogCore';
import { uniqueId } from 'es-toolkit/compat';
import React from 'react';

export type DialogProps = DialogCoreBaseProps & Partial<DialogCoreTypeProps>;

const Dialog: React.FunctionComponent<DialogProps> = ({
  children,
  entranceMotion = 'up',
  entranceMotionDesktop = 'fadeIn',
  variant = 'fullScreen',
  variantDesktop = 'centered',
  maxWidth = 'sm',
  fullWidth = true,
  fullHeight,
  ...props
}) => {
  return (
    <DialogCore
      entranceMotion={entranceMotion}
      entranceMotionDesktop={entranceMotionDesktop}
      variant={variant}
      variantDesktop={variantDesktop}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullHeight={fullHeight}
      {...props}
    >
      {children}
    </DialogCore>
  );
};

/*
 * A common pattern a11y pattern with Dialogs is to focus their close buttons on their first being shown.
 * This utility hook that returns a value that can be passed to the TransitionProps= property
 * of a Dialog, and the closeButtonId prop of a DialogHeading underneath it.
 */
export function useAutoFocusingCloseButton(): {
  closeButtonId: string;
  TransitionProps: DialogProps['TransitionProps'];
} {
  const closeButtonIdRef = React.useRef(uniqueId('closeButtonId'));

  const onEntered = () => {
    window?.setTimeout(() => {
      const closeButton = document.getElementById(closeButtonIdRef.current);
      if (closeButton) {
        closeButton.focus();
        closeButton.setAttribute('data-autofocus-complete', 'true');
      }
    }, 0);
  };

  return { closeButtonId: closeButtonIdRef.current, TransitionProps: { onEntered } };
}

export default Dialog;
